<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
      <el-breadcrumb-item>แลกของรางวัล</el-breadcrumb-item>
    </el-breadcrumb>

    <v-row>
      <v-col :cols="3"> </v-col>
      <v-col :cols="6">
        <el-card class="mt-3">
          <el-form
            :label-position="`top`"
            ref="form"
            :model="form"
            label-width="150px"
          >
            <el-form-item label="ร้านค้า">
              <el-select
                v-model="selectedShopId"
                style="width: 100%"
                class="mb-2"
                filterable
                placeholder="เลือกร้านค้า"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.shop_id"
                  :label="item.name"
                  :value="item.shop_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="รหัสแลกของรางวัล (จากลูกค้า)">
              <el-input
                v-model="form.unique_key"
                placeholder="xxxxxx"
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button
            :disabled="selectedShopId == null"
            style="width:100%;"
            type="danger"
            size="small"
            @click.native="search()"
            >ค้นหา</el-button
          >
        </el-card>
      </v-col>
      <v-col :cols="3"> </v-col>
    </v-row>
    <v-dialog
      v-model="showDialog"
      persistent
      scrollable
      max-width="600px"
      transition="dialog-bottom-transition"
    >
      <el-card class="mt-3">
        <template v-if="redemption != null">
          <h2>ของรางวัล</h2>
          <v-divider class="mb-3"></v-divider>
          <div class="text-center" v-if="showActions">
            <!-- 
            <img
              :src="redemption.items_json[0].image"
              style="width:180px; border-radius:20px;"
            />
            -->
            <h2 class="my-2">{{ redemption.items_json[0].name }}</h2>
            <el-tag type="success"
              >มูลค่า :
              {{ redemption.items_json[0].regular_price }} คะแนน</el-tag
            >
          </div>
          <div v-else>
            แลกของรางวัลเรียบร้อยแล้ว
          </div>

          <v-divider class="my-3"></v-divider>
          <v-row v-if="showActions">
            <v-col>
              <el-button
                style="width:100%;"
                size="small"
                @click.native="showDialog = false"
                >ปิด</el-button
              >
            </v-col>
            <v-col>
              <el-button
                :disabled="selectedShopId == null"
                style="width:100%;"
                type="danger"
                size="small"
                @click.native="submit()"
                >ยืนยัน</el-button
              >
            </v-col>
          </v-row>
          <v-row v-if="!showActions">
            <v-col>
              <el-button
                style="width:100%;"
                size="small"
                @click.native="showDialog = false"
                >ปิด</el-button
              >
            </v-col>
          </v-row>
        </template>
        <template v-if="redemption == null">
          <div class="text-center">
            {{ error }}
            <div>
              <el-button size="small" @click.native="showDialog = false"
                >ปิด</el-button
              >
            </div>
          </div>
        </template>
      </el-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Service from "@/services";
export default {
  components: {},
  props: [],
  data() {
    return {
      isLoading: true,
      showDialog: false,
      showActions: true,
      error: "",
      form: {
        unique_key: "",
      },
      redemption: null,
      selectedShopId: null,
      shopList: [],
    };
  },
  created() {
    this.isLoading = false;
    Service.Shop.gets().then((res) => {
      this.shopList = res.data.filter(function(item) {
        return item.status == "published";
      });

      if (this.ent_id != null) {
        this.shopList = this.shopList.filter((item) => {
          return item.ent_id == this.ent_id;
        });
      }
    });
  },
  methods: {
    search() {
      Service.Membership.searchRedemption(this.form)
        .then((res) => {
          if (res.success) {
            this.redemption = res.data.redemption;
            this.showDialog = true;
          }
        })
        .catch((e) => {
          console.log(e);
          this.redemption = null;
          this.selectedShopId = null;
          this.error = e;
          this.showDialog = true;
        });
    },
    submit() {
      let data = {
        unique_key: this.form.unique_key,
        shop_id: this.selectedShopId,
      };
      Service.Membership.acceptRedemption(data).then((res) => {
        if (res.success) {
          this.$swal("แลกของรางวัลเรียบร้อยแล้ว");
          this.showActions = false;
        }
      });
    },
  },
};
</script>
